// ## debe estar autenticado para ello se usa el middleware
import auth from "@/middleware/auth";

// ## LAS RUTAS NO SE DEFINEN ANIDADAS PORQUE VUE PRESENTA PROBLEMAS
// ## PATH BASE
const base = "/requests-gestor-impuestos";
// ##  ROL PERMITIDO
// ## NOMBRE DE LA RUTA
const nameRoute = "request-of-gestor-impuestos";
const permisosSindicalesRequestV2Routes = [
  {
    path: base,
    name: nameRoute,
    component: () =>
      import("@/views/modules/permisos-sindicales/requests/v2/index.vue"),
    props: (route) => ({ query: route.query }),
    meta: {
      middleware: [auth],
      roles: ["gestor-impuestos", "relaciones-laborales"],
    },
  },
  {
    path: base.concat("/:id"),
    name: nameRoute.concat("-show"),
    component: () =>
      import("@/views/modules/permisos-sindicales/requests/v2/show.vue"),
    meta: {
      middleware: [auth],
      roles: ["gestor-impuestos", "relaciones-laborales"],
    },
  },
  {
    path: base.concat("/:id/management"),
    name: nameRoute.concat("-management"),
    component: () =>
      import("@/views/modules/permisos-sindicales/requests/v2/management.vue"),
    meta: {
      middleware: [auth],
      roles: ["gestor-impuestos", "relaciones-laborales"],
    },
  },
];

export { permisosSindicalesRequestV2Routes };
